// @flow
import React from "react";
import PropTypes from "prop-types";
import FormControl from "react-bootstrap/lib/FormControl";
import { getClassNames } from "data/utils";
import styles from "components/NativeSelect/NativeSelect.module.css";
import FormsyEditorBase from "components/ExtraAttributes/EditorControl/FormsyEditorBase";
import loc from "i18next";
import { components } from "react-select";
const { DownChevron } = components;

export const FilesSizes = [
    "NotSet",
    "Empty",
    "Tiny",
    "Small",
    "Medium",
    "Large",
    "Huge",
    "VeryHuge",
];

const FileSizeEditorControl = ({
    autoFocus,
    index,
    value,
    onChange,
    style,
    className,
    id,
    filterEditorProps,
    isRequired,
    afterHeaderComponentClass,
    ...props
}: {
    autoFocus?: boolean,
    index: number,
    value?: string,
    onChange: Function,
    style?: Object,
    className?: string,
    id?: string,
    filterEditorProps: Object,
    afterHeaderComponentClass?: Node,
}) => (
    <FormsyEditorBase
        onChange={onChange}
        value={value}
        required={isRequired ? "isDefaultRequiredValue" : undefined}
        render={(_value, changeValue) => (
            <div className={styles.wrapper}>
                <FormControl
                    autoFocus={autoFocus}
                    componentClass="select"
                    value={_value || "NotSet"}
                    onChange={
                        /* istanbul ignore next */ (e) => {
                            if (e.currentTarget.value === "NotSet") {
                                changeValue({ currentTarget: { value: "" } });
                            } else changeValue(e);
                        }
                    }
                    style={style}
                    className={getClassNames(className, styles.select)}
                    id={id}
                >
                    {FilesSizes.map((fileSize, index) => {
                        return (
                            <option
                                key={index}
                                value={fileSize}
                                disabled={isRequired && index === 0}
                                {...props}
                            >
                                {loc.t(
                                    `common:filter.FileSize.${
                                        isRequired && index === 0
                                            ? "Choose"
                                            : fileSize
                                    }`
                                )}
                            </option>
                        );
                    })}
                </FormControl>
                <DownChevron className={styles.icon} />
            </div>
        )}
        {...props}
    />
);

FileSizeEditorControl.displayName = "FileSizeEditorControl";
FileSizeEditorControl.propTypes = {
    autoFocus: PropTypes.bool,
    index: PropTypes.number.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};
export default FileSizeEditorControl;
